<template>
    <v-card>
        <v-card-text>
            <div>
                <v-expansion-panels popout>
                    <template v-for="(group, index) in groupedVertraege">
                        <v-row :key="index" :style="getFrameStyle(group)">
                            <v-col cols="12" style="padding-left: 0px;">
                                <v-chip outlined :style="{ color: group.color }">
                                    {{ group.label }}
                                </v-chip>
                            </v-col>
                            <!--  v-for="(item, i) in sortedVertraege" :key="i" -->
                            <v-expansion-panel  v-for="(item, i) in group.items" :key="`${index}-${i}`"
                                @click="getVertrag(item)"
                            >
                                <v-expansion-panel-header>{{ item }}</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-card>
                                        <v-form>
                                            <v-container>
                                                <v-row >
                                                    <v-chip v-if="$store.state.vertraege.vertraege[item].abgeschlossen" color="red" outlined style="margin: 10px;">
                                                        Abgeschlossen
                                                    </v-chip>
                                                    <v-chip v-else color="green" outlined style="margin: 10px;">
                                                        Offen
                                                    </v-chip>
                                                </v-row>
                                                <v-row style="display: flex; align-items: center;">
                                                    <v-chip color="primary" outlined style="margin: 0px 10px;">
                                                        konfiguriert?
                                                    </v-chip>  
                                                    <v-checkbox v-model="$store.state.vertraege.vertraege[item].konfiguriert"
                                                        :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                        @change="onKonfiguriert($event, item)">
                                                    </v-checkbox>                                              
                                                </v-row>
                                            
                                                <v-row>
                                                    <v-col cols="12" md="4">
                                                        <v-autocomplete v-model="$store.state.vertraege.vertraege[item].product"
                                                            :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                            :items="$store.state.vertraege.alleProduktnamen" dense filled
                                                            label="Auslösendes Produkt"
                                                            @change="onVertragsProduktChange($event, item)"></v-autocomplete>
                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-text-field label="Anzahl der Tranchen"
                                                            :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                            v-model="anzahl" filled type="number"
                                                            @change="onNumberChange($event, item)" />

                                                    </v-col>
                                                    <v-col cols="12" md="4">
                                                        <v-text-field label="automatisch Schließen nach"
                                                            v-model="vertragAutoclose" filled type="datetime-local"
                                                            :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                            @change="onVertragAutoclose($event, item)" />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-card style="width:100%">
                                                        <v-card-title>
                                                            Handelszeiten
                                                        </v-card-title>
                                                        <v-card-text :key="tradingTimesKey">
                                                            <v-expansion-panels style="width:100%">
                                                                <v-expansion-panel>
                                                                    <v-expansion-panel-header>Konfiguration</v-expansion-panel-header>
                                                                    <v-expansion-panel-content>
                                                                        <v-data-table
                                                                            :headers="tradingHeaders"
                                                                            :items="tradingDays"
                                                                            hide-default-footer
                                                                            disable-sort
                                                                            dense
                                                                            class="elevation-1"
                                                                        >
                                                                            <template v-slot:item.active="{ item }">
                                                                                <v-switch
                                                                                    v-model="trading.tradingtimes[item.key].active"
                                                                                    color="success"
                                                                                    hide-details
                                                                                    dense
                                                                                ></v-switch>
                                                                            </template>
                                                                            <template v-slot:item.from="{ item }">
                                                                                <v-text-field
                                                                                    v-model="trading.tradingtimes[item.key].from"
                                                                                    type="time"
                                                                                    dense
                                                                                    hide-details
                                                                                    :disabled="!trading.tradingtimes[item.key].active"
                                                                                    @change="validateFromTime(item.key)"
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <template v-slot:item.to="{ item }">
                                                                                <v-text-field
                                                                                    v-model="trading.tradingtimes[item.key].to"
                                                                                    type="time"
                                                                                    dense
                                                                                    hide-details
                                                                                    :disabled="!trading.tradingtimes[item.key].active"
                                                                                    @change="validateToTime(item.key)"
                                                                                ></v-text-field>
                                                                            </template>
                                                                        </v-data-table>
                                                                        <v-btn color="primary" class="mt-4" @click="saveTradingTimes">
                                                                            Speichern
                                                                        </v-btn>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-row>
                                                <v-row>
                                                    <v-card style="width:100%">
                                                        <v-card-title>
                                                            Zeitbereiche
                                                            <v-spacer />
                                                            <v-text-field label="Neuen Zeitbereich erstellen"
                                                                v-model="neuerZeitbereichName"
                                                                :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                                @change="createNewZeitbereich(item)"></v-text-field>
                                                            <v-btn class="mx-2" fab dark small color="green lighten-2"
                                                                @click="createNewZeitbereich(item)"><v-icon>mdi-folder-plus</v-icon></v-btn>
                                                        </v-card-title>
                                                        <v-card-text :key="zeitbereichsKey">

                                                            <v-expansion-panels>
                                                                <v-expansion-panel
                                                                    v-for="(zeitbereich, j) in Object.keys($store.state.vertraege.vertraege[item].zeitbereiche)"
                                                                    :key="j">
                                                                    <v-expansion-panel-header>{{ zeitbereich
                                                                    }}</v-expansion-panel-header>
                                                                    <v-expansion-panel-content>
                                                                        <v-container>
                                                                            <v-row>
                                                                                <v-col cols="6">
                                                                                    <v-text-field label="Stopp-Loss"
                                                                                        :readonly="$store.state.vertraege.vertraege[item].abgeschlossen"
                                                                                        v-model="$store.state.vertraege.vertraege[item].zeitbereiche[zeitbereich].delta"
                                                                                        filled type="number" step=".01"
                                                                                        prefix="€"
                                                                                        @change="updateZeitbereich($event, item, zeitbereich)" />
                                                                                </v-col>
                                                                                <v-col cols="6">
                                                                                    <v-text-field label="Limit"
                                                                                        :readonly="$store.state.vertraege.vertraege[item].abgeschlossen"
                                                                                        v-model="$store.state.vertraege.vertraege[item].zeitbereiche[zeitbereich].value"
                                                                                        filled type="number" step=".01"
                                                                                        prefix="€"
                                                                                        @change="updateZeitbereich($event, item, zeitbereich)" />
                                                                                </v-col>

                                                                            </v-row>
                                                                            <v-row>
                                                                                <v-card style="width:100%"
                                                                                    :key="zeitbereichsTranchenKey">
                                                                                    <v-card-text>
                                                                                        <v-data-table
                                                                                            :headers="zeitbereichsHeader"
                                                                                            :items="zeitbereichTableData($store.state.vertraege.vertraege[item].zeitbereiche[zeitbereich].bereiche)"
                                                                                            class="elevation-1">
                                                                                            <template v-slot:item.id="{ item }">
                                                                                                {{ new
                                                                                                    Date(item.id *
                                                                                                        1000).toLocaleString('de-DE') }}

                                                                                            </template>
                                                                                            <template
                                                                                                v-slot:item.actions="{ item }">
                                                                                                <v-icon small class="mr-2"
                                                                                                    @click="editItem(item)">
                                                                                                    mdi-pencil
                                                                                                </v-icon>
                                                                                                <v-icon small
                                                                                                    @click="deleteItem(item, zeitbereich)">
                                                                                                    mdi-delete
                                                                                                </v-icon>
                                                                                            </template>
                                                                                            <template v-slot:top>
                                                                                                <v-toolbar flat>
                                                                                                    <v-toolbar-title>Zuordnungen</v-toolbar-title>
                                                                                                    <v-divider class="mx-4"
                                                                                                        inset
                                                                                                        vertical></v-divider>
                                                                                                    <v-spacer></v-spacer>
                                                                                                    <v-dialog
                                                                                                        v-model="zeitbereichsDialog"
                                                                                                        max-width="500px">
                                                                                                        <template
                                                                                                            v-slot:activator="{ on, attrs }">
                                                                                                            <v-btn
                                                                                                                color="primary"
                                                                                                                dark
                                                                                                                class="mb-2"
                                                                                                                v-bind="attrs"
                                                                                                                v-on="on">
                                                                                                                Neue Zuordnung
                                                                                                            </v-btn>
                                                                                                        </template>
                                                                                                        <v-card>
                                                                                                            <v-card-title>
                                                                                                                <span class="text-h5">
                                                                                                                    {{ formTitle }}
                                                                                                                </span>
                                                                                                            </v-card-title>

                                                                                                            <v-card-text>
                                                                                                                <v-container>
                                                                                                                    <v-row>
                                                                                                                        <v-col
                                                                                                                            cols="12">
                                                                                                                            <v-text-field
                                                                                                                                v-model="editedItem.timestamp"
                                                                                                                                label="Beginn"
                                                                                                                                type="datetime-local"></v-text-field>
                                                                                                                        </v-col>
                                                                                                                    </v-row>
                                                                                                                    <v-row>
                                                                                                                        <v-col
                                                                                                                            cols="12">
                                                                                                                            <v-select
                                                                                                                                v-model="editedItem.namen"
                                                                                                                                :items="getTranchenList(item, zeitbereich)"
                                                                                                                                chips
                                                                                                                                label="zugeordnete Tranchen "
                                                                                                                                multiple></v-select>
                                                                                                                        </v-col>
                                                                                                                    </v-row>
                                                                                                                </v-container>
                                                                                                            </v-card-text>

                                                                                                            <v-card-actions>
                                                                                                                <v-spacer></v-spacer>
                                                                                                                <v-btn
                                                                                                                    color="blue darken-1"
                                                                                                                    :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                                                                                    text
                                                                                                                    @click="close">
                                                                                                                    Cancel
                                                                                                                </v-btn>
                                                                                                                <v-btn
                                                                                                                    color="blue darken-1"
                                                                                                                    :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                                                                                    text
                                                                                                                    @click="save(item, zeitbereich)">
                                                                                                                    Save
                                                                                                                </v-btn>
                                                                                                            </v-card-actions>
                                                                                                        </v-card>
                                                                                                    </v-dialog>
                                                                                                    <v-dialog
                                                                                                        v-model="zeitbereichsDialogDelete"
                                                                                                        max-width="500px">
                                                                                                        <v-card>
                                                                                                            <v-card-title
                                                                                                                class="text-h5">Sind
                                                                                                                Sie sicher, dass
                                                                                                                Sie diese
                                                                                                                Zuordnung
                                                                                                                löschen
                                                                                                                wollen?</v-card-title>
                                                                                                            <v-card-actions>
                                                                                                                <v-spacer></v-spacer>
                                                                                                                <v-btn
                                                                                                                    color="blue darken-1"
                                                                                                                    :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                                                                                    text
                                                                                                                    @click="closeDelete">Cancel</v-btn>
                                                                                                                <v-btn
                                                                                                                    color="blue darken-1"
                                                                                                                    :disabled="$store.state.vertraege.vertraege[item].konfiguriert"
                                                                                                                    text
                                                                                                                    @click="deleteItemConfirm">OK</v-btn>
                                                                                                                <v-spacer></v-spacer>
                                                                                                            </v-card-actions>
                                                                                                        </v-card>
                                                                                                    </v-dialog>
                                                                                                </v-toolbar>
                                                                                            </template>
                                                                                        </v-data-table>
                                                                                    </v-card-text>
                                                                                </v-card>
                                                                            </v-row>

                                                                        </v-container>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>

                                                        </v-card-text>
                                                    </v-card>
                                                </v-row>
                                                <v-row>
                                                    <v-card style="width:100%">
                                                        <v-card-title>Tranchen</v-card-title>
                                                        <v-card-text>

                                                            <v-simple-table :key="tranchenKey">
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Tranche
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Status
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Datum
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="value in sortedTranchen(item)"
                                                                            :key="value.sort">
                                                                            <td>Tranche {{ value.sort }}</td>
                                                                            <td>{{ value.status }}</td>
                                                                            <td v-if="value.timestamp">{{ new
                                                                                Date(value.timestamp.seconds *
                                                                                    1000).toLocaleString('de-DE') }}</td>
                                                                            <td v-else>&nbsp;</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-row>
                                                <v-row>
                                                    <v-card style="width:100%" :key="vertragsnamenKey">
                                                        <v-card-title>Vertragsnummern</v-card-title>
                                                        <v-card-text>
                                                            <v-simple-table>
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                #
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Vertrag
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Vertragsnehmer
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="vname in $store.state.vertraege.vertragsnummern[item]"
                                                                            :key="vname.name">
                                                                            <td>{{
                                                                                $store.state.vertraege.vertragsnummern[item].indexOf(vname)
                                                                                + 1
                                                                            }}</td>
                                                                            <td>{{ vname }}</td>
                                                                            <td>{{ $store.state.vertraege.vertragsnehmer[vname]
                                                                            }}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-row>

                                            </v-container>

                                        </v-form>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-row>
                    </template>
                </v-expansion-panels>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { format } from "date-fns"

const DEFAULT_TRADINGTIMES = {
    monday: { active: false, from: "09:00", to: "15:00" },
    tuesday: { active: false, from: "09:00", to: "15:00" },
    wednesday: { active: false, from: "09:00", to: "15:00" },
    thursday: { active: false, from: "09:00", to: "15:00" },
    friday: { active: false, from: "09:00", to: "13:00" },
    saturday: { active: false, from: "00:00", to: "00:00" },
    sunday: { active: false, from: "00:00", to: "00:00" }
}

export default {
    data() {
        return {
            ausgesuchtesProdukt: "",
            aktuellerVertrag: null,
            vertraege: [],
            anzahl: 0,
            tranchenKey: 0,
            zeitbereichsKey: 0,
            zeitbereichsTranchenKey: 0,
            vertragsnamenKey: 0,
            neuerZeitbereichName: "",
            trading: {
                tradingtimes: JSON.parse(JSON.stringify(DEFAULT_TRADINGTIMES))
            },
            zeitbereichsHeader: [
                { text: "Start", value: "id" },
                { text: "zugehörige Tranchen", value: "namen", sortable: false },
                { text: "Status", value: "status", sortable: false },
                { text: "Actions", value: "actions", sortable: false },
            ],
            zeitbereichsDialog: false,
            zeitbereichsDialogDelete: false,
            editedIndex: -1,
            editedItem: {
                id: "",
                timestamp: "",
                namen: [],
                status: "offen",
            },
            defaultItem: {
                id: "",
                timestamp: "",
                namen: [],
                status: "offen",
            },
            deleteObject: null,
            vertragAutoclose: new Date(),
            tradingMenuFrom: {},
            tradingMenuTo: {}

        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Neue Zuordnung" : "Zuordnung bearbeiten"
        },
        showAutoclose() {
            if (!this.$store.state.vertraege.vertraege[this.aktuellerVertrag].autoclose) {
                return format(new Date(), "yyyy-MM-dd'T'HH:mm:00.000")
            }
            const date = new Date(this.$store.state.vertraege.vertraege[this.aktuellerVertrag].autoclose * 1000);
            return format(date, "yyyy-MM-dd'T'HH:mm:00.000")
        },
        // sortedVertraege() {
        //     return Object.keys(this.$store.state.vertraege.vertraege).sort((a, b) => {
        //     const vertragA = this.$store.state.vertraege.vertraege[a];
        //     const vertragB = this.$store.state.vertraege.vertraege[b];

        //     return this.getSortValue(vertragA) - this.getSortValue(vertragB);
        //     })
        // }
        groupedVertraege() {
            const groups = [
                { label: "Konfiguriert & Offen", color: "red", items: [] },
                { label: "Konfiguriert & Abgeschlossen", color: "green", items: [] },
                { label: "Nicht Konfiguriert & Abgeschlossen", color: "gray", items: [] },
                { label: "Nicht Konfiguriert & Offen", color: "orange", items: [] },
            ]

            Object.keys(this.$store.state.vertraege.vertraege).forEach((item) => {
                const vertrag = this.$store.state.vertraege.vertraege[item]

                if (vertrag.konfiguriert && !vertrag.abgeschlossen) {
                    groups[0].items.push(item)
                } else if (vertrag.konfiguriert && vertrag.abgeschlossen) {
                    groups[1].items.push(item)
                } else if (!vertrag.konfiguriert && vertrag.abgeschlossen) {
                    groups[2].items.push(item)
                } else {
                    groups[3].items.push(item)
                }
            })
            return groups.filter((group) => group.items.length > 0)
        },
        tradingHeaders() {
            return [
                { text: "Tag", value: "day", sortable: false },
                { text: "Handelstag", value: "active", sortable: false },
                { text: "Von", value: "from", sortable: false },
                { text: "Bis", value: "to", sortable: false },
            ]
        },
        tradingDays() {
            return [
                { key: "monday", day: "Montag" },
                { key: "tuesday", day: "Dienstag" },
                { key: "wednesday", day: "Mittwoch" },
                { key: "thursday", day: "Donnerstag" },
                { key: "friday", day: "Freitag" },
                { key: "saturday", day: "Samstag" },
                { key: "sunday", day: "Sonntag" },
            ]
        }
    },
    methods: {
        // getSortValue(vertrag) {
        //     if (vertrag.konfiguriert && vertrag.abgeschlossen) {
        //     return 1; // Green
        //     } else if (vertrag.konfiguriert && !vertrag.abgeschlossen) {
        //     return 2; // Blue
        //     } else if (!vertrag.konfiguriert && vertrag.abgeschlossen) {
        //     return 3; // Orange
        //     } else {
        //     return 4; // Gray
        //     }
        // },
        // getFilteredVertraege(konfiguriert, abgeschlossen) {
        //     return Object.entries(this.$store.state.vertraege.vertraege)
        //     .filter(([, vertrag]) => vertrag.konfiguriert === konfiguriert && vertrag.abgeschlossen === abgeschlossen)
        //     .map(([key, vertrag]) => ({ id: key, ...vertrag }))
        // },
        // getFrameStyle(vertrag) {
        //     let borderColor = "gray" // Default color

        //     if (vertrag.konfiguriert && vertrag.abgeschlossen) {
        //     borderColor = "green" // Group 1
        //     } else if (vertrag.konfiguriert && !vertrag.abgeschlossen) {
        //     borderColor = "red" // Group 2
        //     } else if (!vertrag.konfiguriert && vertrag.abgeschlossen) {
        //     borderColor = "gray" // Group 3
        //     } else {
        //     borderColor = "orange" // Group 4
        //     }

        //     return {
        //     border: `3px solid ${borderColor}`,
        //     "border-radius": "8px",
        //     padding: "5px",
        //     }
        // },
        getFrameStyle(group) {
            return {
                border: `3px solid ${group.color}`,
                "border-radius": "8px",
                padding: "10px",
                margin: "15px 0",
                width: "100%"
            }
        },
        openTimePicker(event) {
            const input = event.target.closest(".v-input").querySelector("input[type='time']")
            if (input && input.showPicker) {
                input.showPicker()
            }
        },
        validateFromTime(key) {
            if (this.trading.tradingtimes[key].from > this.trading.tradingtimes[key].to) {
                this.trading.tradingtimes[key].from = this.trading.tradingtimes[key].to
            }
        },
        validateToTime(key) {
            if (this.trading.tradingtimes[key].to < this.trading.tradingtimes[key].from) {
                this.trading.tradingtimes[key].to = this.trading.tradingtimes[key].from
            }
        },
        async saveTradingTimes() {
            if (!this.aktuellerVertrag) {
                console.warn("Kein Vertrag ausgewählt")
                return
            }
            await this.$store.dispatch("saveNewTradingTimes", {
                vertrag: this.aktuellerVertrag,
                tradingtimes: JSON.parse(JSON.stringify(this.trading.tradingtimes))
            })
        },
        sortedTranchen(item) {
            const data = this.$store.state.vertraege.vertraege[item].tranchen
            if (!data) {
                return []
            }
            const ret = []
            for (const [key, value] of Object.entries(data)) {
                const idx = parseInt(key.split(" ")[1])
                value.sort = idx
                ret.push(value)
            }
            ret.sort((a, b) => a.sort - b.sort)
            return ret
        },
        getTranchenList(item, zeitbereich) {
            console.log(item, zeitbereich)
            const alleTranchen = Object.keys(this.$store.state.vertraege.vertraege[item].tranchen);
            console.log(zeitbereich)
            return alleTranchen
        },
        zeitbereichTableData(obj) {
            let out = [];
            if (obj != null) {
                for (const el in obj) {
                    out.push(obj[el])
                }
            }

            return out
            //return [{ id: 1, namen: ["1", "2"], status: "okay" }]
        },
        getVertrag: function (item) {
            console.log("getVertrag");
            this.$store.dispatch("attachVertragsnummern", { docid: item });
            this.$store.dispatch("attachVertragZeitbereiche", { docid: item });
            this.$store.dispatch("attachVertragTranchen", { docid: item }).then(() => {
                const counter = Object.keys(this.$store.state.vertraege.vertraege[item].tranchen).length;
                this.anzahl = counter;
            });
            if (this.$store.state.vertraege.vertraege[item].autoclose) {
                this.vertragAutoclose = format(new Date(this.$store.state.vertraege.vertraege[item].autoclose * 1000), "yyyy-MM-dd'T'HH:mm:00.000");
            } else {
                this.vertragAutoclose = format(new Date(0), "yyyy-MM-dd'T'HH:mm:00.000");
            }

            this.$store.dispatch("fetchNewTradingTimes", { vertrag: item }).then((data) => {
                if (data && data.trading && data.trading.tradingtimes) {
                    const times = data.trading.tradingtimes
                    Object.keys(times).forEach(key => {
                        if (times[key].from && times[key].from.length > 5) {
                            times[key].from = times[key].from.substring(0, 5)
                        }
                        if (times[key].to && times[key].to.length > 5) {
                            times[key].to = times[key].to.substring(0, 5)
                        }
                    })
                    this.trading.tradingtimes = times
                } else {
                    this.trading.tradingtimes = JSON.parse(JSON.stringify(DEFAULT_TRADINGTIMES))
                }
            })

            this.aktuellerVertrag = item
        },
        onKonfiguriert: function (change, item) {
            this.$store.dispatch("onKonfiguriert", { docid: item }).then(() => {
                this.tranchenKey++;
            })
        },
        onNumberChange: function (change, item) {
            const newNumber = parseInt(change)
            // const tranchenPrefix = "Tranche ";
            const counter = Object.keys(this.$store.state.vertraege.vertraege[item].tranchen).length;


            // wegfallende
            if (counter > newNumber) {
                for (const [key, value] of Object.entries(this.$store.state.vertraege.vertraege[item].tranchen)) {
                    if (value.sort > newNumber) {
                        console.log("delete" + key)
                        delete this.$store.state.vertraege.vertraege[item].tranchen[key]
                    }
                }
            } else {
                let idxNew = counter + 1
                for (idxNew; idxNew <= newNumber; idxNew++) {
                    const tranchenname = `Tranche ${idxNew}`
                    this.$store.state.vertraege.vertraege[item].tranchen[tranchenname] = {
                        "status": "offen"
                    }
                }
            }

            //this.tranchenKey++;


            this.$store.dispatch("updateTranchen", { item: item, value: newNumber, counter: counter }).then(() => {
                this.tranchenKey++;
            })

        },
        onVertragsProduktChange(change, item) {
            console.log(change, item);
            this.$store.state.vertraege.vertraege[item].product = change;
            this.$store.dispatch("updateVertragsprodukt", { item: item, value: change })
        },
        onVertragAutoclose(change, item) {
            console.log(change, item);
            const timestamp = Math.floor(new Date(change).valueOf() / 1000)
            this.$store.state.vertraege.vertraege[item].autoclose = timestamp;
            this.$store.dispatch("updateVertragsAutoclose", { item: item, value: timestamp })
        },
        createNewZeitbereich: function (item) {
            if (!this.neuerZeitbereichName || this.neuerZeitbereichName == "" || Object.keys(this.$store.state.vertraege.vertraege[item].zeitbereiche).includes(this.neuerZeitbereichName)) {
                return;
            }
            this.$store.state.vertraege.vertraege[item].zeitbereiche[this.neuerZeitbereichName] = {
                "id": this.neuerZeitbereichName,
                "bereiche": {},
                "delta": 0,
                "value": 0,
                "date": {
                    nanoseconds: 0,
                    seconds: Math.floor(Date.now() / 1000)
                }
            }
            this.$store.dispatch("insertZeitbereich", { item: item, zeitbereich: this.neuerZeitbereichName });
            this.zeitbereichsKey++;
            this.neuerZeitbereichName = ""
        },
        close() {
            this.zeitbereichsDialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        closeDelete() {
            this.zeitbereichsDialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
            this.deleteObject = {}
        },
        editItem(item) {
            const date = new Date(item.id * 1000);
            this.editedItem = {
                id: format(date, "yyyy-MM-dd'T'HH:mm:00.000"),
                timestamp: format(date, "yyyy-MM-dd'T'HH:mm:00.000"),
                namen: item.namen,
                status: item.status
            }
            this.editedIndex = 1
            this.zeitbereichsDialog = true
        },
        deleteItem(item, bereich) {
            this.deleteObject = {
                vertrag: this.aktuellerVertrag,
                bereich: bereich,
                id: item.id
            }
            this.zeitbereichsDialogDelete = true
        },
        updateZeitbereich(wert, item, zeitbereich) {
            console.log(wert, item, zeitbereich);
            this.$store.dispatch("updateZeitbereich", { item: item, zeitbereich: zeitbereich })
        },
        deleteItemConfirm() {
            delete this.$store.state.vertraege.vertraege[this.deleteObject.vertrag].zeitbereiche[this.deleteObject.bereich].bereiche[this.deleteObject.id];
            this.$store.dispatch("updateZeitbereich", { item: this.deleteObject.vertrag, zeitbereich: this.deleteObject.bereich })
            this.deleteObject = {}
            this.zeitbereichsTranchenKey++;
            this.closeDelete()
        },
        save(item, bereich) {
            console.log("save",  this.editedItem, item, bereich)

            const id = Math.floor(new Date(this.editedItem.id).valueOf() / 1000);
            const timestamp = Math.floor(new Date(this.editedItem.timestamp).valueOf() / 1000);

            delete this.$store.state.vertraege.vertraege[item].zeitbereiche[bereich].bereiche[id]
            this.$store.state.vertraege.vertraege[item].zeitbereiche[bereich].bereiche[timestamp] = {
                id: timestamp,
                namen: this.editedItem.namen,
                status: "offen",
            }
            console.log("call dispatch");
            this.$store.dispatch("updateZeitbereich", { item: item, zeitbereich: bereich })
            this.zeitbereichsTranchenKey++;
            this.close()
        },
    },
    async mounted() {
        // SignIn Check
        if (!this.$store.state.auth.isSignedIn) {
            this.$router.push("/login");
            return;
        }

        this.$store.dispatch("holeAlleProduktnamen");
        this.$store.dispatch("attachVertraege");
        //this.$store.dispatch("getTradingTimes");
    },
    watch: {
        zeitbereichsDialog(val) {
            val || this.close()
        },
        zeitbereichsDialogDelete(val) {
            val || this.closeDelete()
        },
        
    },
};
</script>

<style></style>